import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './pages/MainPage.jsx';
import MessagePage from './pages/MessagePage.jsx';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/message" element={<MessagePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
